export default __webpack_public_path__ + "static/media/program-icon.17f76691.svg";